import PathWrapper from "core/PathWrapper";

export const giftCertificatesPath = new PathWrapper('gift-certificates')